import React from "react";
import { NavLogoMobile } from "./assets";
import { mustBeSubmenu } from "./helper";
import { BottomNavigationItem, BottomNavigationSubItem } from "./items";
import { IBottomItem, ITopItem, ITopItemCore } from "./types";

export interface IMobileNavBarListsProps {
	readonly topItems?: ReadonlyArray<ITopItem>;
	readonly bottomItems?: ReadonlyArray<IBottomItem>;
	readonly bottomBarHoverUnderline: boolean;
}
const MobileNavBarLists: React.FC<IMobileNavBarListsProps> = ({
	topItems,
	bottomItems,
	bottomBarHoverUnderline,
}) => {
	const mobileBottomItems = bottomItems?.filter(({ allowedScreenSizeMode }) => {
		return (
			allowedScreenSizeMode === "mobile" ||
			allowedScreenSizeMode === "any" ||
			allowedScreenSizeMode === undefined
		);
	});
	const topItemsFlat: ITopItemCore[] = [];
	topItems?.forEach(topItem => {
		if (topItem.subItems) {
			topItem.subItems.forEach(subItem => {
				topItemsFlat.push(subItem);
			});
		} else if (!mustBeSubmenu(topItem.navLogoKind)) {
			topItemsFlat.push(topItem);
		}
	});

	return (
		<>
			{mobileBottomItems && mobileBottomItems.length > 0 ? (
				<ul
					role="menubar"
					className={`epic-header-flex epic-header-flex-col epic-header-items-center epic-header-gap-4 epic-header-pb-4 epic-header-border-b-2 epic-header-bg-[color:var(--epic-nav-bottom-bar-back-color)] epic-header-border-[color:var(--epic-nav-mobile-navigation-pane-border-color)] epic-header-text-2xl ${topItemsFlat && topItemsFlat.length > 0 ? "" : "epic-header-mb-24"}`}
					id="navbar_mobile_bottomitems"
				>
					{mobileBottomItems.map(bottomItem => {
						if (bottomItem.subItems) {
							const subItems = bottomItem.subItems.filter(({ allowedScreenSizeMode }) => {
								return (
									allowedScreenSizeMode === undefined ||
									allowedScreenSizeMode === "mobile" ||
									allowedScreenSizeMode === "any"
								);
							});
							return (
								<li
									key={`nav_bar_mobile_item_${bottomItem.label}`}
									id={`nav_bar_mobile_item_${bottomItem.label.replaceAll(" ", "_")}`}
									className="epic-header-flex epic-header-flex-col epic-header-text-center epic-header-text-[color:var(--epic-nav-bottom-bar-submenu-item-text-color)]"
								>
									{bottomItem.label}
									<ul className={`grid grid-cols-1 text-base`}>
										{subItems.map(subItem => {
											return (
												<li
													key={`nav_bar_mobile_subitem_${bottomItem.label}_${subItem.label}`}
													id={`nav_bar_mobile_subitem_${
														bottomItem.label
													}_${subItem.label.replaceAll(" ", "_")}`}
													className={`epic-header-flex epic-header-justify-center epic-header-gap-6 epic-header-w-full`}
												>
													<BottomNavigationSubItem
														subItem={subItem}
														transparentBackground={true}
														className={`epic-header-justify-center`}
														hoverUnderline={bottomBarHoverUnderline}
														inMobilePopup
													/>
												</li>
											);
										})}
									</ul>
								</li>
							);
						} else if (bottomItem.href) {
							return (
								<li
									key={`nav_bar_mobile_item_${bottomItem.label}`}
									id={`nav_bar_mobile_item_${bottomItem.label.replaceAll(" ", "_")}`}
								>
									<BottomNavigationItem
										inMobilePopup
										item={bottomItem}
										hoverUnderline={bottomBarHoverUnderline}
									/>
								</li>
							);
						}
					})}
				</ul>
			) : null}
			{topItemsFlat && topItemsFlat.length > 0 ? (
				<ul
					className="epic-header-flex epic-header-flex-col epic-header-items-stretch epic-header-gap-4 epic-header-py-4 epic-header-border-b-2 epic-header-border-[color:var(--epic-nav-mobile-navigation-pane-border-color)] epic-header-bg-[color:var(--epic-nav-top-bar-background-color)] epic-header-mb-24"
					id="navbar_mobile_topitems"
				>
					{topItemsFlat
						? topItemsFlat.map(topItem => {
								if (topItem.selected) {
									return null;
								}
								return (
									<div
										key={`nav_bar_mobile_logo_${topItem.navLogoKind}`}
										id={`nav_bar_mobile_logo_${topItem.navLogoKind}`}
										className="epic-header-flex epic-header-items-stretch epic-header-justify-center epic-header-h-10"
									>
										<NavLogoMobile
											navLogoKind={topItem.navLogoKind}
											selected={false}
											tooltip={topItem.tooltip}
											big
										/>
									</div>
								);
							})
						: null}
				</ul>
			) : null}
		</>
	);
};
export default MobileNavBarLists;

